import { render, staticRenderFns } from "./TwBenchmarkFilterPanel.vue?vue&type=template&id=478c6f66&scoped=true"
import script from "./TwBenchmarkFilterPanel.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkFilterPanel.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkFilterPanel.vue?vue&type=style&index=0&id=478c6f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c6f66",
  null
  
)

export default component.exports